export enum EnumKnowledgeDocumentStatus {
  Queued = 'queued',
  Processing = 'processing',
  Ready = 'ready',
  Failed = 'failed',
  Deleting = 'deleting',
  /** Status não reconhecido: o backend pode ampliar o conjunto. Nunca tratado como pronto. */
  Unknown = 'unknown'
}
